(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }

    function initSection(section) {
      if (!section || section.__alveoBlog) return;
      section.__alveoBlog = true;

      var track = section.querySelector('[data-alveo-track]');
      var dotsContainer = section.querySelector('[data-alveo-dots]');
      var prevBtn = section.querySelector('[data-alveo-prev]');
      var nextBtn = section.querySelector('[data-alveo-next]');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.children);
      if (!cards.length) return;

      function getVisible() {
        var w = window.innerWidth;
        var styles = window.getComputedStyle(section);
        var raw;
        if (w >= 1024) raw = styles.getPropertyValue('--alveo-desktop');
        else if (w >= 768) raw = styles.getPropertyValue('--alveo-tablet');
        else raw = styles.getPropertyValue('--alveo-mobile');
        var v = parseFloat(raw);
        return isNaN(v) || v < 1 ? 1 : v;
      }

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        var visible = getVisible();
        var dotCount = Math.max(1, cards.length - Math.floor(visible) + 1);

        if (dotCount <= 1) {
          dotsContainer.hidden = true;
          return;
        }
        dotsContainer.hidden = false;

        for (var i = 0; i < dotCount; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'alveo-blog__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Ir para o artigo ' + (i + 1));
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          dot.dataset.index = String(i);
          dotsContainer.appendChild(dot);
        }
      }

      function scrollToCard(index) {
        var target = cards[index];
        if (!target) return;
        var left = target.offsetLeft;
        if (prefersReducedMotion()) {
          track.scrollLeft = left;
        } else {
          track.scrollTo({ left: left, behavior: 'smooth' });
        }
      }

      function getCurrentIndex() {
        var pos = track.scrollLeft;
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var dist = Math.abs(cards[i].offsetLeft - pos);
          if (dist < bestDist) { bestDist = dist; best = i; }
        }
        return best;
      }

      function updateActive() {
        var dots = dotsContainer ? dotsContainer.children : [];
        var dotCount = dots.length;
        var current = getCurrentIndex();
        var active = Math.min(current, Math.max(0, dotCount - 1));
        for (var i = 0; i < dotCount; i++) {
          dots[i].setAttribute('aria-selected', i === active ? 'true' : 'false');
        }
        // Sem páginas para navegar (cards ≤ visíveis): ambas as setas ficam desabilitadas
        var hasPages = dotCount > 0;
        if (prevBtn) prevBtn.disabled = !hasPages || current === 0;
        if (nextBtn) nextBtn.disabled = !hasPages || current >= dotCount - 1;
      }

      if (dotsContainer) {
        dotsContainer.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('.alveo-blog__dot');
          if (!btn) return;
          scrollToCard(parseInt(btn.dataset.index, 10) || 0);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        scrollToCard(Math.max(0, getCurrentIndex() - 1));
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        scrollToCard(Math.min(cards.length - 1, getCurrentIndex() + 1));
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateActive();
        });
      }, { passive: true });

      section.__alveoRefresh = function () {
        buildDots();
        updateActive();
      };

      buildDots();
      updateActive();
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-alveo-blog]');
      for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
    }

    var onResize = debounce(function () {
      var nodes = document.querySelectorAll('[data-alveo-blog]');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].__alveoRefresh) nodes[i].__alveoRefresh();
      }
    }, 150);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    window.addEventListener('resize', onResize);

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector ? e.target.querySelector('[data-alveo-blog]') : null;
      if (s) initSection(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION_SELECTOR = '[data-alveo-ugc]';
    var MUTE_KEY = 'alveoUgcMute';
    var NAV_LOCK_MS = 350;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }

    function getMute() {
      try { return sessionStorage.getItem(MUTE_KEY) === '1'; } catch (e) { return false; }
    }
    function setMute(muted) {
      try { sessionStorage.setItem(MUTE_KEY, muted ? '1' : '0'); } catch (e) {}
    }

    function initSection(section) {
      if (!section || section.__alveoUgc) return;
      section.__alveoUgc = true;

      var track = section.querySelector('[data-alveo-track]');
      var dotsContainer = section.querySelector('[data-alveo-dots]');
      var prevBtn = section.querySelector('[data-alveo-prev]');
      var nextBtn = section.querySelector('[data-alveo-next]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-alveo-slide]'));
      if (!slides.length) return;

      var animating = false;

      // ====== Layout: computa slide-w e padding em JS pra evitar feedback loop com CSS calc ======
      function applyLayout() {
        var viewportEl = section.querySelector('.alveo-ugc__viewport');
        if (!viewportEl) return;
        var containerWidth = viewportEl.clientWidth;
        if (!containerWidth) return;

        var styles = getComputedStyle(section);
        var visible = parseFloat(styles.getPropertyValue('--ugc-visible')) || 1;
        var gap = parseFloat(styles.getPropertyValue('--ugc-gap')) || 16;

        var slideWidth = (containerWidth - (visible - 1) * gap) / visible;
        if (slideWidth <= 0) return;

        // Slide width em pixels — independente da padding do track
        track.style.setProperty('--ugc-slide-w', slideWidth + 'px');

        // Padding-inline pra centralizar primeiro/último slide
        var padding = Math.max(0, (containerWidth - slideWidth) / 2);
        track.style.paddingLeft = padding + 'px';
        track.style.paddingRight = padding + 'px';
      }

      // ====== Navegação ======
      function scrollToSlide(index, instant) {
        var target = slides[index];
        if (!target) return;
        var trackWidth = track.clientWidth;
        var slideWidth = target.offsetWidth;
        var left = target.offsetLeft - (trackWidth - slideWidth) / 2;
        if (instant || prefersReducedMotion()) {
          track.scrollLeft = left;
        } else {
          track.scrollTo({ left: left, behavior: 'smooth' });
        }
      }

      function getCurrentIndex() {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var slideCenter = slides[i].offsetLeft + slides[i].offsetWidth / 2;
          var dist = Math.abs(slideCenter - center);
          if (dist < bestDist) { bestDist = dist; best = i; }
        }
        return best;
      }

      function navigate(index) {
        if (animating) return;
        if (index < 0 || index >= slides.length) return;
        var current = getCurrentIndex();
        if (index === current) return;
        animating = true;
        // Pausa vídeo do slide que vai sair (mantém o frame atual)
        pauseSlideVideo(slides[current]);
        scrollToSlide(index);
        setTimeout(function () { animating = false; }, NAV_LOCK_MS);
      }

      // ====== Estado ativo (escala + dots + setas) ======
      function updateDistances(current) {
        for (var i = 0; i < slides.length; i++) {
          var distance = Math.abs(i - current);
          slides[i].dataset.distance = String(distance);
          // Pausa vídeos que saíram do centro (preserva o frame atual)
          if (distance > 0) {
            pauseSlideVideo(slides[i]);
          }
        }
      }

      function updateActive() {
        var current = getCurrentIndex();
        var dots = dotsContainer ? dotsContainer.children : [];
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-selected', i === current ? 'true' : 'false');
        }
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === slides.length - 1;
        updateDistances(current);
      }

      // ====== Dots ======
      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        if (slides.length <= 1) {
          dotsContainer.hidden = true;
          return;
        }
        dotsContainer.hidden = false;
        for (var i = 0; i < slides.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'alveo-ugc__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Ir para o vídeo ' + (i + 1));
          dot.setAttribute('aria-selected', 'false');
          dot.dataset.index = String(i);
          dotsContainer.appendChild(dot);
        }
      }

      // ====== Player inline ======
      function pauseSlideVideo(slide) {
        if (!slide) return;
        var video = slide.querySelector('video');
        if (video && !video.paused) {
          try { video.pause(); } catch (e) {}
        }
        // NÃO removemos o vídeo — mantém o frame atual
      }

      function playInline(slide) {
        var card = slide.querySelector('.alveo-ugc__card');
        var media = slide.querySelector('.alveo-ugc__media');
        var src = slide.dataset.videoSrc;
        if (!media || !src) {
          console.warn('[alveo-ugc] Sem src de vídeo no slide.');
          return;
        }

        // Pausa qualquer outro vídeo da mesma section (mantém frames)
        for (var i = 0; i < slides.length; i++) {
          if (slides[i] !== slide) pauseSlideVideo(slides[i]);
        }

        var existing = media.querySelector('video');
        if (existing) {
          // Já existe: retoma do frame atual
          existing.muted = getMute();
          var p = existing.play();
          if (p && p.catch) p.catch(function () {
            existing.muted = true;
            setMute(true);
            existing.play().catch(function () {});
          });
          card.classList.add('is-playing');
          return;
        }

        // Cria <video> e injeta dentro do media
        var video = document.createElement('video');
        video.className = 'alveo-ugc__video';
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.muted = getMute();
        video.setAttribute('controlsList', 'nodownload');
        video.setAttribute('disablePictureInPicture', 'false');
        video.addEventListener('volumechange', function () {
          setMute(video.muted);
        });
        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
        });

        media.appendChild(video);
        card.classList.add('is-playing');

        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            // Autoplay com som bloqueado pelo browser: tenta mudo
            video.muted = true;
            setMute(true);
            video.play().catch(function () {});
          });
        }
      }

      // ====== Event handlers ======
      if (dotsContainer) {
        dotsContainer.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('.alveo-ugc__dot');
          if (!btn) return;
          navigate(parseInt(btn.dataset.index, 10) || 0);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        navigate(getCurrentIndex() - 1);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        navigate(getCurrentIndex() + 1);
      });

      // Click no media → toca inline. Só permite se o slide é o central.
      slides.forEach(function (slide, idx) {
        var media = slide.querySelector('[data-alveo-open]');
        if (!media) return;
        media.addEventListener('click', function (e) {
          var current = getCurrentIndex();
          if (idx !== current) {
            // Clicou num card lateral: primeiro centraliza, não toca
            e.preventDefault();
            navigate(idx);
            return;
          }
          playInline(slide);
        });
      });

      // Scroll listener: atualiza estado durante o scroll
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateActive();
        });
      }, { passive: true });

      // ====== Refresh externo (resize / section:load) ======
      section.__alveoRefresh = function () {
        var current = getCurrentIndex();
        applyLayout();
        scrollToSlide(current, true);
        updateActive();
      };

      // ====== Init ======
      buildDots();
      // Espera o layout estabilizar (CSS aplicado) antes de medir
      requestAnimationFrame(function () {
        applyLayout();
        var middleIdx = Math.floor((slides.length - 1) / 2);
        scrollToSlide(middleIdx, true);
        updateActive();
        // Revela o track depois do layout pronto (evita flash de cards no tamanho errado)
        track.setAttribute('data-ready', '');
      });
    }

    function initAll() {
      var nodes = document.querySelectorAll(SECTION_SELECTOR);
      for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
    }

    var onResize = debounce(function () {
      var nodes = document.querySelectorAll(SECTION_SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].__alveoRefresh) nodes[i].__alveoRefresh();
      }
    }, 150);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    window.addEventListener('resize', onResize);

    // Shopify theme editor: reinit quando section é adicionada/editada
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector ? e.target.querySelector(SECTION_SELECTOR) : null;
      if (s) initSection(s);
    });

    // Re-centraliza quando a section é selecionada no editor (preview pode mudar tamanho)
    document.addEventListener('shopify:section:select', function (e) {
      var s = e.target.querySelector ? e.target.querySelector(SECTION_SELECTOR) : null;
      if (s && s.__alveoRefresh) s.__alveoRefresh();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
